import React, { useState, useEffect, Suspense } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ReactSession } from 'react-client-session';
import axios from 'axios'
import { Markup } from 'interweave';
import LoadingBar from 'react-top-loading-bar'
import {Helmet} from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import {
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon,
    PinterestIcon,
    EmailIcon
} from "react-share";

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer'
import Comments from '../Comments/Comments';
import SubscribeButton from '../Global/SubscribeButton'

import styles from '../../App.module.css'
import classes from './Image.module.css'

import noThumb from "../../images/no-thumb.jpg";
import RelatedImages from './RelatedImages/RelatedImages'

function Image() {
    const { id, title } = useParams();
    const [progress, setProgress] = useState(10);
    const [image, setImage] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [albums, setAlbums] = useState([]);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [tags, setTags] = useState([]);
    const [liked, setLiked] = useState(0);
    const [isLiked, setIsLiked] = useState(false);
    ReactSession.setStoreType("localStorage");
  
    const logged_user = ReactSession.get("logged_user");

    useEffect(() => {
        try{
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }catch(ex){}
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/image.php?id=${id}`)
        .then(response => {
            setImage(response.data);
            setLiked(response.data.liked || 0);
            response.data.tags !== '' && setTags(response.data.tags.split(","));

            setProgress(100);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }).catch(error => {
            console.log(error);
        })
    }, [id, title])

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`, {
                user_id: logged_user,
                action: 'GET_MY_ALBUMS'
            }, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(res => {
                // console.log(res.data);
                setAlbums(res.data);
            }).catch(error => {
                console.log(error);
            });
    }, [logged_user])

    const updateLikes = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/heart.php`,
            {
                uid: logged_user,
                image_id: id,
                type: 2
            }, {
                headers: {
                "Content-Type": "multipart/form-data",
                }
            }).then(response => {
                setLiked(response.data.liked);

                if(response.data.is_liked === 1) {
                    setIsLiked(true);
                }else if(response.data.is_liked === 0) {
                    setIsLiked(false);
                }
            }).catch(error => {
                console.log(error);
            })
    }

    const handleLike = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/heart.php`, {
                uid: logged_user,
                image_id: id,
                type: 1
            }, {
                headers: {
                "Content-Type": "multipart/form-data",
                }
            }).then(response => {
                updateLikes();
            }).catch(error => {
                console.log(error);
            })
    }

    useEffect(() => {
        if(logged_user) {
            updateLikes();
        }
    } , [logged_user])

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    }

    const addToAlbum = (play_id) => {
        const toast_id = toast.loading("Please wait...");
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/album.php`, {
                user_id: logged_user,
                play_id: play_id,
                image_id: id,
                action: 'ADD_TO_ALBUM'
            }, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then(res => {
                // console.log(res.data);
                toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false, closeOnClick: true, rtl: true});
            }).catch(err => {
                console.log(err);
            });
    }

    const config = "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30";

    return (
        <>
            <Helmet>
                <title>{image.title || 'Image'} - Wesharez</title>
                <meta name="description" content={image.description ? image.description.replace(/<[^>]*>?/gm, '').slice(0, 270) : ''} />
                <meta name="keywords" content={tags.toString() || ''} />
                <meta property="og:image" content={image.source}/>
            </Helmet>
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <Header />
            <div className={styles.main_body}>
                <Suspense fallback="<div>Please wait...</div>">
                <Sidebar active="images" />
                </Suspense>
                <Suspense fallback="<div>Please wait...</div>">
                    <div className={styles.main_content + ` main-content`}>
                        <div className="image-component p-4 mb-5">
                            <div className="mb-5">
                                <div className="row">
                                    <div className="col-md-7 image-holder">
                                        <div className={classes.image}>
                                            <img src={image.source} onError={e => {e.target.src = noThumb}} alt={image.title} onClick={() => setIsOpen(true)} />
                                            {isOpen && (
                                                <Lightbox
                                                    mainSrc={image.source}
                                                    onCloseRequest={() => setIsOpen(false)}
                                                />
                                            )}
                                        </div>
                                        <div className={classes.description}>
                                            <h4>Description</h4>
                                            <p><Markup content={image.description} /></p>
                                        </div>
                                        {
                                            tags.length !== 0 && <div className={classes.tags}>
                                            <h5>Tags:</h5>
                                            <ul className='p-0'>
                                                {
                                                  tags.map((tag, index) => {
                                                    return (
                                                      <li key={index}><a href="/">{tag}</a></li>
                                                    )
                                                  })
                                                }
                                            </ul>
                                          </div>
                                        }
                                    </div>
                                    <div className="col-md-5 img-inner">
                                        <ins className='adsbygoogle mb-4'
                                            style={{ display: 'block' }}
                                            data-ad-client='ca-pub-8126596259429304'
                                            data-ad-slot='3209374230'
                                            data-ad-format='auto'
                                        />
                                        <div className={classes.owner}>
                                            <Link to={`/profile/${image.user_id}/${image.nice_url}`} className={classes.owner_avatar}>
                                                {/* <img src="https://assets.codepen.io/3306515/IMG_2025.jpg" alt='' /> */}
                                                <img src={image.avatar} onError={e => {e.target.src = noThumb}} alt={image.owner} />
                                                <span className={classes.owner_name}>{image.owner}</span>
                                            </Link>
                                            <div className="btn-group">
                                                <SubscribeButton size="sm" uid={image.user_id} />
                                            </div>
                                        </div>
                                        <div className={classes.divider}></div>
                                        <div className={classes.cute}>
                                            <h3>
                                                {
                                                    image.channel_name && <Link to={`/channel/${image.channel_name}/${image.category}`} title="Art">{image.channel_name} : </Link>
                                                }
                                                <span className='text-muted'><Markup content={image.title}></Markup></span>
                                            </h3>
                                            <p className='text-muted'> {image.time_ago}</p>
                                        </div>
                                        <div className={classes.divider}></div>
                                        <div className={classes.interaction_icons}>
                                            <Link to={false} onClick={() => handleLike()}>
                                                <i className={`fa-solid fa-heart ${isLiked && classes.is_liked}`}></i>
                                                <span>{liked}</span>
                                            </Link>
                                            <a href="/">
                                            <i className="fa-solid fa-eye"></i>
                                                <span>{image.views}</span>
                                            </a>
                                            <Link to={false}>
                                                <i className="fa-solid fa-circle-plus" onClick={() => toggleMenu()}></i>
                                                <ul className={`dropdown-menu ${classes.albums} ${isMenuOpen ? classes.active : ''}`} aria-labelledby="dLabel">
                                                    {
                                                        albums && albums.map && albums.map((album, index) => {
                                                            return (
                                                                <li id="PAdd-13" onClick={() => addToAlbum(album.id)} key={index}><a href="/"><i className="fa-sharp fa-solid fa-circle-dot"></i>{album.title}</a></li>
                                                            )
                                                        })
                                                    }
                                                    <div className="dropdown-divider"></div>
                                                    <li><Link to="/dashboard/add-album"><i className="fa-sharp fa-solid fa-plus"></i>Create album</Link></li>
                                                </ul>
                                            </Link>
                                        </div>
                                        <div className={classes.divider}></div>
                                        <div className={classes.share}>
                                            <h5 className='text-muted'>Share on social media:</h5>
                                            <div className={styles.social_share_buttons}>
                                                <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://twitter.com/intent/tweet?url=${window.location.href}&text=${image.title}`, "Popup", config)}>
                                                    <TwitterIcon size={32} round={true} />
                                                </Link>
                                                <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}&title=${image.title}`, "Popup", config)}>
                                                    <LinkedinIcon size={32} round={true} />
                                                </Link>
                                                <Link to={false} className={`${styles.social__icon}`} onClick={() => window.open(`https://pinterest.com/pin/create/link/?url=${window.location.href}&title=${image.title}&media=${image.thumb}&description=${image.title}`, "Popup", config)}>
                                                    <PinterestIcon size={32} round={true} />
                                                </Link>
                                                <a className={`${styles.social__icon}`} href={`whatsapp://send?text=${window.location.href}`} data-action="share/whatsapp/share">
                                                    <WhatsappIcon size={32} round={true} />
                                                </a>
                                                <a className={`${styles.social__icon}`} href={`mailto:?subject=${image.title}&body=${window.location.href}`}>
                                                    <EmailIcon size={32} round={true} />
                                                </a>
                                            </div>
                                        </div>
                                        {/* <div className={classes.divider}></div> */}
                                        {/* <div className="Comments_message__wU2C+ mt-3 mb-3">
                                            <div className="Comments_avatar__C6NAq">
                                                <a href="/">
                                                    <img src="https://assets.codepen.io/3306515/IMG_2025.jpg" alt="" />
                                                </a>
                                            </div>
                                            <div className="Comments_comment__C6BuR">
                                                <form action="#" method="post">
                                                    <textarea className="form-control" rows="3" defaultValue="Share what you think?"></textarea>
                                                    <button className="btn btn-primary" type="submit">Submit</button>
                                                </form>
                                            </div>
                                        </div> */}
                                        {
                                            Comments(id, 2)
                                        }
                                    </div>
                                </div>
                            </div>
                            {/* Releted Images */}
                            <ins className='adsbygoogle mb-5'
                                style={{ display: 'block' }}
                                data-ad-client='ca-pub-8126596259429304'
                                data-ad-slot='3209374230'
                                data-ad-format='auto'
                            />
                            <RelatedImages id={id} />
                        </div>
                        <Footer />
                    </div>
                </Suspense>
            </div>
        </>
    )
}

export default Image